interface PosthogBootstrapGate {
	waitForRelease(): Promise<void>;
	release(): void;
	reset(): void;
}

export function createPosthogBootstrapGate(): PosthogBootstrapGate {
	let released = false;
	let releasePromise: Promise<void> | null = null;
	let releaseResolve: (() => void) | null = null;

	function ensureReleasePromise(): Promise<void> {
		if (released) {
			return Promise.resolve();
		}
		releasePromise ??= new Promise<void>((resolve) => {
			releaseResolve = resolve;
		});
		return releasePromise;
	}

	return {
		waitForRelease() {
			return ensureReleasePromise();
		},
		release() {
			if (released) {
				return;
			}
			released = true;
			releaseResolve?.();
			releaseResolve = null;
			releasePromise = null;
		},
		reset() {
			// Resolve any in-flight waiter so `ensureInitialized` continuations do not
			// hang forever when identity bootstrap aborts (they must re-check consent
			// and bootstrap id before calling `init`).
			const resolve = releaseResolve;
			releaseResolve = null;
			releasePromise = null;
			released = false;
			resolve?.();
		},
	};
}
